import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { JoyajoyImage, JoyajoyImageFile } from '../JoyajoyImage';

import styles from './WebStoreProductCell.module.css';

export type WebStoreProductCellProps = {
  name: string;
  image: JoyajoyImageFile;
  purchasedAt: Date;
  confirmedReward: string | undefined;
  isManagementReward: boolean;
};

export const WebStoreProductCell = memo((props: WebStoreProductCellProps) => {
  const { name, image, purchasedAt, confirmedReward, isManagementReward } =
    props;
  const { t, i18n } = useTranslation();
  const options: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  };

  const formattedDate = purchasedAt
    ? new Intl.DateTimeFormat(i18n.language, options).format(purchasedAt)
    : undefined;

  return (
    <div className={styles.productCell}>
      <div className={styles.image}>
        <JoyajoyImage className={styles.productImage} {...image} />
      </div>
      <div className={styles.detailContainer}>
        <div className={styles.name}>{name}</div>
        {formattedDate ? (
          <div className={styles.purchaseDate}>
            {t('Purchased: ')} {formattedDate}
          </div>
        ) : null}
        <div className={styles.confirmRow}>
          <div className={styles.confirmedReward}>
            {t(
              isManagementReward
                ? 'Confirmed Management Reward: '
                : 'Confirmed Reward: ',
            )}
          </div>
          <div className={styles.reward}>{confirmedReward}</div>
        </div>
      </div>
    </div>
  );
});
